export default "/_next/static/chunks/fonts/Montserrat UltraLight-53b077802659022c8508e6e2786eb4da.otf";